import { HttpParams } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { AnnouncementDetailComponent } from './announcement-detail/announcement-detail.component';
import { OnInit } from '@angular/core/core';
import { AnnouncementsService } from './shared/announcements.service';
import { Component } from '@angular/core';
import * as vis from 'vis';
import * as moment from 'moment';

@Component({
  selector: 'app-announcements',
  templateUrl: 'announcements.component.html',
  styleUrls: ['announcements.component.scss'],
  viewProviders: [AnnouncementDetailComponent],
})
export class AnnouncementsComponent implements OnInit {
  announcements: any[];
  selectedId: string;
  selected: any;

  categories: any[] = [
    { id: 'homepage', name: 'Điều chỉnh tuyến' },
    { id: 'news', name: 'Tin tức' },
  ];

  showPublishOnly: Boolean = true;

  cat: String = 'homepage';

  timeline: vis.Timeline;

  constructor(private announcementsService: AnnouncementsService, private route: ActivatedRoute) {}

  select(item: IAnnouncement) {
    this.selectedId = item._id;
    this.selected = item;

    this.timeline.setSelection([item._id]);
    this.timeline.focus([item._id]);
  }

  selectById(id: string) {
    const item = this.announcements.find((a: IAnnouncement) => {
      return a._id.toString() === id;
    });

    if (item) {
      this.selectedId = item._id;
      this.selected = item;
    }
  }

  setupTimeline(annoucements: IAnnouncement[]) {
    // DOM element where the Timeline will be attached
    const container = document.getElementById('visualization');

    // Create a DataSet (allows two way data-binding)
    const data: vis.DataItem[] = annoucements.map((a) => {
      const start = a.startDate || a.ts;
      const end = a.endDate || null;
      return <vis.DataItem>{
        id: a._id,
        content: a.title,
        start: start,
        end: end,
        className: a.cat,
      };
    });

    const items = new vis.DataSet(data);

    // Configuration for the Timeline
    const options: vis.TimelineOptions = {
      showCurrentTime: false,
      width: '100%',
      height: '50vh',
      clickToUse: true,
    };

    // Create a Timeline
    this.timeline = new vis.Timeline(container, items, options);

    this.timeline.on('select', (properties: any) => {
      if (properties.items && properties.items.length > 0) {
        this.selectById(properties.items[0]);
      }
    });
  }

  ngOnInit() {
    this.announcementsService.query({ url: '/' }).subscribe((res: any) => {
      this.announcements = res;

      this.setupTimeline(this.announcements);

      this.route.params.subscribe((params) => {
        const id = params['id'];

        if (id) {
          this.announcements.forEach((announcement) => {
            if (announcement._id === id) {
              this.select(announcement);
            }
          });
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/announcements/announcements.component.ts